module.exports = __webpack_public_path__ + "img/new2.08a61b70.png";